import Pill from './pill';

export default function SmallPill({ onClick, removable, children }) {
    return (
        <Pill onClick={onClick} removable={removable} type="small">{ children }</Pill>
    )
}